import * as Types from '../../types.generated';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type BulkCreateLibraryItemFolderMembershipsMutationVariables = Types.Exact<{
  inputs: Array<Types.LibraryItemFolderMembershipInput> | Types.LibraryItemFolderMembershipInput;
}>;


export type BulkCreateLibraryItemFolderMembershipsMutation = { __typename?: 'Mutation', createLibraryItemFolderMemberships: { __typename?: 'LibraryItemFolderMembershipsMutationResult', success: boolean, memberships: Array<{ __typename?: 'LibraryItemFolderMembership', id: string, libraryItem: { __typename?: 'LibraryItem', id: string }, folder?: { __typename?: 'Folder', id: string, position: string } | null }> } };


export const BulkCreateLibraryItemFolderMembershipsDocument = gql`
    mutation BulkCreateLibraryItemFolderMemberships($inputs: [LibraryItemFolderMembershipInput!]!) {
  createLibraryItemFolderMemberships(inputs: $inputs) {
    success
    memberships {
      id
      libraryItem {
        id
      }
      folder {
        id
        position
      }
    }
  }
}
    `;
export type BulkCreateLibraryItemFolderMembershipsMutationFn = Apollo.MutationFunction<BulkCreateLibraryItemFolderMembershipsMutation, BulkCreateLibraryItemFolderMembershipsMutationVariables>;

/**
 * __useBulkCreateLibraryItemFolderMembershipsMutation__
 *
 * To run a mutation, you first call `useBulkCreateLibraryItemFolderMembershipsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBulkCreateLibraryItemFolderMembershipsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bulkCreateLibraryItemFolderMembershipsMutation, { data, loading, error }] = useBulkCreateLibraryItemFolderMembershipsMutation({
 *   variables: {
 *      inputs: // value for 'inputs'
 *   },
 * });
 */
export function useBulkCreateLibraryItemFolderMembershipsMutation(baseOptions?: Apollo.MutationHookOptions<BulkCreateLibraryItemFolderMembershipsMutation, BulkCreateLibraryItemFolderMembershipsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BulkCreateLibraryItemFolderMembershipsMutation, BulkCreateLibraryItemFolderMembershipsMutationVariables>(BulkCreateLibraryItemFolderMembershipsDocument, options);
      }
export type BulkCreateLibraryItemFolderMembershipsMutationHookResult = ReturnType<typeof useBulkCreateLibraryItemFolderMembershipsMutation>;
export type BulkCreateLibraryItemFolderMembershipsMutationResult = Apollo.MutationResult<BulkCreateLibraryItemFolderMembershipsMutation>;
export type BulkCreateLibraryItemFolderMembershipsMutationOptions = Apollo.BaseMutationOptions<BulkCreateLibraryItemFolderMembershipsMutation, BulkCreateLibraryItemFolderMembershipsMutationVariables>;